import React, { useState } from 'react';

interface ClientsType {
    [key: string]: { [key: string]: string };
}

interface SearchModalProps {
    isVisible: boolean;
    onClose: () => void;
    onSearch: (ticketData: any) => void;
    clients: ClientsType;
    states: any[];
}

const FilterEquipmentsModal: React.FC<SearchModalProps> = ({ isVisible, onClose, onSearch, clients, states }) => {
    const [selectedClientId, setSelectedClientId] = useState('');
    const [selectedClientPlants, setSelectedClientPlants] = useState<string[]>([]);
    const [selectedPlant, setSelectedPlant] = useState('');
    const [selectedState, setSelectedState] = useState('');

    const handleSearchClick = async () => {
        const filters = {
            clientId: selectedClientId,
            plantId: selectedPlant,
            state: selectedState,
        };
        onSearch(filters);
        onClose();
    };

    const handleClientChange = (event: any) => {
        setSelectedPlant('');
        const selectedKey = event.target.value;
        setSelectedClientId(selectedKey);
        const plants: any = clients[selectedKey];
        setSelectedClientPlants(plants);
    };

    const handleClearFilters = () => {
        setSelectedClientId('');
        setSelectedClientPlants([]);
        setSelectedPlant('');
        setSelectedState('');
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="top">
                    <div className="search">
                        <span className="material-icons-outlined search-icon">search</span>
                        <p className="buscar-header">FILTRAR</p>
                    </div>
                    <div className="close-button" onClick={onClose}>
                        <span className="material-icons-outlined close-icon">close</span>
                    </div>
                </div>
                <div className="body-filter-ticket">
                    {selectedState === 'Instalado' && (
                        <div className="body-filter-dropdown">
                            <select
                                id="cliente"
                                value={selectedClientId}
                                onChange={(e) => handleClientChange(e)}
                                className="dropdown"
                            >
                                <option value="">CLIENTE</option>
                                {clients && Object.keys(clients).length > 0 ? (
                                    Object.keys(clients).map((clientKey) => (
                                        <option key={clientKey} value={clientKey}>
                                            {clientKey}
                                        </option>
                                    ))
                                ) : (
                                    <option value="" disabled>
                                        No hay clientes disponibles
                                    </option>
                                )}
                            </select>

                            <select
                                id="plantaDropdown"
                                value={selectedPlant}
                                className="dropdown"
                                onChange={(e) => setSelectedPlant(e.target.value)}
                                disabled={!selectedClientId || !selectedClientPlants || Object.keys(selectedClientPlants).length === 0}
                            >
                                <option value="">Seleccione una planta</option>
                                {selectedClientPlants && Object.entries(selectedClientPlants).length > 0 ? (
                                    Object.entries(selectedClientPlants).map(([key, value]: any) => (
                                        <option key={key} value={key}>
                                            {value}
                                        </option>
                                    ))
                                ) : (
                                    <option value="" disabled>
                                        No hay plantas disponibles
                                    </option>
                                )}
                            </select>
                        </div>
                    )}
                    <div className="body-filter-dropdown">
                        <select
                            value={selectedState}
                            onChange={(e) => setSelectedState(e.target.value)}
                            className="dropdown"
                        >
                            <option value="">ESTADO</option>
                            {states?.map((state: any, index) => (
                                <option key={index} value={state}>
                                    {state}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="filter-buttons">
                    <button onClick={handleSearchClick} className="filter-search-button">BUSCAR</button>
                    <button onClick={handleClearFilters} className="clear-button">
                        BORRAR FILTROS
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FilterEquipmentsModal;
